import React from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import YcrContent from './YcrContent'
import { Card } from '../../../../components/ui/Card'

const YCR = () => {
    return (
        <DashboardMaster>
            <section className='p-2 md:px-5'>
                <YcrContent />
            </section>
        </DashboardMaster>
    )
}

export default YCR
